export const APP_STATUS = {
  LOADING: 'loading',
  FILTERING: 'filtering',
  LOADED: 'loaded',
  ERROR: 'error',
};
